import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import AdminLayout from "./Layout/AdminLayout";
import AuthLayout from "./Layout/AuthLayout";
import Documentation from "./Tuning/Pages/Documentation/Documentation";

function App() {

  // x---------------------------------x Use From Redux Store x---------------------------------x
  const themeMode = useSelector((state) => state.themeMode.themeMode);
  const themeColor = useSelector((state) => state.theme.themeColor);
  const borderStroke = useSelector((state) => state.stroke.borderStroke);
  const boxLayout = useSelector((state) => state.boxLayout.boxLayout);
  const monochrome = useSelector((state) => state.monochrome.monochrome);
  const borderRadius = useSelector((state) => state.borderRadius.borderRadius);
  const iconColor = useSelector((state) => state.iconColor.iconColor);
  const gradientColor = useSelector((state) => state.gradientColor.gradientColor);

  const location = useLocation();
  const pathname = location.pathname;

  // x---------------------------------x Path For Routes x---------------------------------x
  const authTitleMapping = {
    "/signin": "Signin",
    "/signup": "Signup",
    "/password-reset": "PasswordReset",
    "/two-step": "TwoStep",
    "/lockscreen": "Lockscreen",
    "/maintenance": "Maintenance",
    "/404": "NoPage",
  };

  // x---------------------------------x Authentication Routes x---------------------------------x
  const isAuthRoute = authTitleMapping[pathname];

  return (
    <>
      {isAuthRoute ? (
        // x---------------------------------x Authentication Layout x---------------------------------x
        <AuthLayout />
      ) : pathname.startsWith("/docs") ? (
        // x---------------------------------x Documantation Page x---------------------------------x
        <Documentation
          themeMode={themeMode}
          themeColor={themeColor}
          borderStroke={borderStroke}
          boxLayout={boxLayout}
          monochrome={monochrome}
          borderRadius={borderRadius}
          gradientColor={gradientColor}
        />
      ) : (
        // x---------------------------------x Admin Layout x---------------------------------x
        <AdminLayout
          themeMode={themeMode}
          themeColor={themeColor}
          borderStroke={borderStroke}
          boxLayout={boxLayout}
          monochrome={monochrome}
          borderRadius={borderRadius}
          iconColor={iconColor}
          gradientColor={gradientColor}
        />
      )}
    </>
  );
}

export default App;
